import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Button, Checkbox } from 'antd';
import { getSex, getBodyPartText, getStateName } from '../utils';
import { eventListener, isIncluded } from '../utils';
import qs from 'query-string';

class ApplyInfo extends React.Component {
  static propTypes = {
    reportInfo: PropTypes.object,
    isSmall: PropTypes.bool,
    role: PropTypes.array,
    toViewer: PropTypes.func,
    historyListVisible: PropTypes.func,
    dangerOnchange: PropTypes.func,
    dangerChecked: PropTypes.bool,
  };

  state = {
    showModal: true,
    productionId: '101',
  };

  //查看申请单弹出框
  applyVisible = () => {
    const { showModal, productionId } = this.state;
    const { reportInfo } = this.props;
    const { state } = reportInfo;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId] = ['10019', 'mk0001'];
      if (showModal) elementId = 'ns-002';
      else elementId = 'ns-001';
    } else if (state === 21 || state === 26) {
      [pageId, moduleId] = ['10020', 'mk0001'];
      if (showModal) elementId = 'ns-002';
      else elementId = 'ns-001';
    } else {
      [pageId, moduleId] = ['10021', 'mk0001'];
      if (showModal) elementId = 'ns-002';
      else elementId = 'ns-001';
    }
    eventListener({ ...eventData, pageId, moduleId, elementId });

    this.setState({ showModal: !showModal });
  };

  toViewer = () => {
    const { productionId } = this.state;
    const { reportInfo } = this.props;
    const { state } = reportInfo;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId, elementId] = ['10019', 'mk0001', 'ns-003'];
    } else if ([21, 26].includes(state)) {
      [pageId, moduleId, elementId] = ['10020', 'mk0001', 'ns-003'];
    } else {
      [pageId, moduleId, elementId] = ['10021', 'mk0001', 'ns-003'];
    }
    eventListener({ ...eventData, pageId, moduleId, elementId });

    this.props.toViewer();
  };

  historyListVisible = flag => {
    const { productionId } = this.state;
    const { reportInfo } = this.props;
    const { state } = reportInfo;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId, elementId] = ['10019', 'mk0001', 'ns-007'];
    } else if ([21, 26].includes(state)) {
      [pageId, moduleId, elementId] = ['10020', 'mk0001', 'ns-007'];
    } else {
      [pageId, moduleId, elementId] = ['10021', 'mk0001', 'ns-007'];
    }
    eventListener({ ...eventData, pageId, moduleId, elementId });

    this.props.historyListVisible(flag);
  };
  dangerOnchange = e => {
    const { reportInfo } = this.props;
    if (reportInfo.state === 11) {
      const { productionId } = this.state;
      const eventData = { productionId, pageId: '10019', moduleId: 'mk0001' };
      eventListener({ ...eventData, elementId: 'ns-013' });
    }

    this.props.dangerOnchange(e);
  };
  render() {
    const source = ['门诊', '住院', '体检'];
    const list = ['普通', '白天急诊', '夜间急诊'];
    const { reportInfo, isSmall, role, dangerChecked } = this.props;
    const { showModal } = this.state;
    const isAnonymity = role.includes('S');
    const { state } = reportInfo;

    const bodyPartText = getBodyPartText(reportInfo.parts);

    const detail = qs.parse(window.location.search).detail;
    const stateArray = [11, 21, 26, 40];
    return (
      <>
        <div className="report-userinfo">
          <Row className={isSmall ? 'report-user-small' : ''}>
            <Col span={5}>姓名：{isAnonymity ? '***' : reportInfo.patName}</Col>
            <Col span={5}>年龄：{isAnonymity ? '***' : reportInfo.patAge}</Col>
            <Col span={5}>
              性别：
              {isAnonymity ? '***' : getSex(reportInfo.patSex)}
            </Col>
            <Col span={9}>检查时间：{reportInfo.applicationTime}</Col>
          </Row>
          <Row className={isSmall ? 'report-user-small' : ''}>
            <Col span={5}>检查类型：{reportInfo.modality}</Col>
            <Col span={10}>
              <div className="report-bodypart-text">
                检查部位：
                <span title={bodyPartText}>{bodyPartText}</span>
              </div>
            </Col>
            <Col span={5}>
              <Checkbox
                onChange={e => this.dangerOnchange(e)}
                checked={dangerChecked}
                disabled={
                  !stateArray.includes(state) ||
                  (detail === 'true' && !stateArray.includes(state))
                }
              >
                危急值
              </Checkbox>
            </Col>
          </Row>
          <div style={{ display: showModal ? '' : 'none' }}>
            <Row>
              <Col span={10}>
                <div className="report-bodypart-text">
                  患者编号：
                  <span title={reportInfo.studyUid}>{reportInfo.studyUid}</span>
                </div>
              </Col>
              <Col span={14}>
                <div className="report-bodypart-text">
                  检查编号：
                  <span title={reportInfo.accessionNumber}>
                    {reportInfo.accessionNumber}
                  </span>
                </div>
              </Col>
              <Col span={10}>
                <div className="report-bodypart-text">
                  影像编号：
                  <span title={reportInfo.imagesNumber}>
                    {reportInfo.imagesNumber}
                  </span>
                </div>
              </Col>
              <Col span={14}>
                <div className="report-bodypart-text">
                  住院号：
                  <span title={reportInfo.hospitalizedNumber}>
                    {reportInfo.hospitalizedNumber}
                  </span>
                </div>
              </Col>
              <Col span={10}>
                <div className="report-bodypart-text">
                  急诊：
                  <span title={list[reportInfo.emergencyFlag] || ''}>
                    {list[reportInfo.emergencyFlag] || ''}
                  </span>
                </div>
              </Col>
              <Col span={14}>
                <div className="report-bodypart-text">
                  患者来源：
                  <span title={source[reportInfo.patientSource] || ''}>
                    {source[reportInfo.patientSource] || ''}
                  </span>
                </div>
              </Col>
              <Col span={24}>
                <div className="report-bodypart-text">
                  <span className="title">申请项目：</span>
                  <span className="content" title={reportInfo.applicationItem}>
                    {reportInfo.applicationItem}
                  </span>
                </div>
              </Col>
              <Col span={24}>
                <div className="report-info-flex">
                  <span className="title">病情描述：</span>
                  <span className="content" title={reportInfo.description}>
                    {reportInfo.description}
                  </span>
                </div>
              </Col>
              <Col span={24}>
                <div className="report-info-flex">
                  <span className="title">既往病史：</span>
                  <span className="content" title={reportInfo.medicalHistory}>
                    {reportInfo.medicalHistory}
                  </span>
                </div>
              </Col>
              <Col span={10}>
                <div className="report-bodypart-text">
                  申请医生：
                  <span title={reportInfo.applicationUserName}>
                    {reportInfo.applicationUserName}
                  </span>
                </div>
              </Col>
              <Col span={14}>
                <div className="report-bodypart-text">
                  申请时间：
                  <span title={reportInfo.applicationTime}>
                    {reportInfo.applicationTime}
                  </span>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div
          className={
            'report-status-title ' + (isSmall ? ' report-user-small' : '')
          }
        >
          报告状态：{getStateName(reportInfo.state)}
          <div className="buttons">
            <Button size="small" onClick={this.applyVisible}>
              {this.state.showModal ? '收起申请单' : '查看申请单'}
            </Button>
            <Button size="small" onClick={this.toViewer}>
              查看影像
            </Button>
            {isIncluded(['M', 'T'], role) && (
              <Button
                size="small"
                onClick={() => this.historyListVisible(true)}
              >
                历史记录
              </Button>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ApplyInfo;
